// import { AceEditorModule } from 'ng2-ace-editor';
 import { NgModule } from "@angular/core";
import { NgSelectModule } from "@ng-select/ng-select";
// import { SummernoteComponent } from "../../shared/summernote/summernote.component";
import { SafePipe } from 'src/app/shared/filter-pipe/safe.pipe';
import { NgxUtilitiesModule } from '../ngx-utilities/ngx-utilities.module';
import { BackButtonComponent } from './back-button/back-button.component';
import { AceEditorModule } from "ngx-ace-editor-wrapper";
// import { AceModule } from 'ngx-ace-wrapper';
// const DEFAULT_ACE_CONFIG: AceConfigInterface = {
//   tabSize: 2,
// };

// import { ACE_CONFIG } from 'ngx-ace-wrapper';   
// import { AceConfigInterface } from 'ngx-ace-wrapper';
@NgModule({ 
  declarations: [
    // SummernoteComponent,
    // AceEditorModule,
    SafePipe,
    BackButtonComponent
  ],
  imports: [
    AceEditorModule,
  ],
  exports: [
    // NgSelectModule,
    // SummernoteComponent,
    
    BackButtonComponent,
    
    SafePipe
  ],
})
export class OtherUtilitiesModule {}
